import { StyledText } from "./styles";

type ComponetProps = {
  children?: string | number | JSX.Element | any[];
  inline?: boolean;
  center?: boolean;
  left?: boolean;
  canOverflow?: boolean;
  size?: "title" | "subtitle" | "body" | "caption" | "small" | "tiny";
  color?:
    | "inherit"
    | "white"
    | "black"
    | "light"
    | "regular"
    | "danger"
    | "ghost-regular"
    | "ghost-light"
    | "ghost-white";
};

export default function MainText({
  children,
  inline,
  center,
  left,
  canOverflow,
  size = "body",
  color = "black",
  ...props
}: ComponetProps) {
  return (
    <StyledText
      style={{ textAlign: center ? "center" : left ? "left" : undefined }}
      size={size}
      color={color}
      inline={inline}
      canOverflow={canOverflow}
      {...props}
    >
      {children}
    </StyledText>
  );
}
